module.exports = __webpack_public_path__ + "themes/fq/img/button-normal@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/button-normal@2x.png
// module id = 8
// module chunks = d-game